import { OperationTypeNode } from "graphql";
import isOnline from "src/components/10-atoms/network/utils/isOnline";
import tokenStorage from "src/modules/authentication/storage/token/storage";
import { IUserRole } from "src/modules/common/user/types";
import extractNodeInfoFromQueryVariables from "./extractNodeInfoFromQueryVariables";
import extractRootResolver from "./extractRootResolver";
import isOnlinePreferredQueries from "./isOnlinePreferredQueries";
import isResolverAvailable from "./isResolverAvailable";
import isSyncBoxSynced from "./isSyncBoxSynced";
export default async function shouldResolveOffline(operation) {
    try {
        const isSuperAdmin = tokenStorage.getRoles().includes(IUserRole.SUPER_ADMIN);
        if (isOnline() && isSuperAdmin)
            return false;
        const rootResolver = extractRootResolver(operation);
        if (!rootResolver)
            return false;
        /**
         * The below sequence of checks must not be altered.
         *
         * If resolver is not available, we can't resolve offline.
         * Else resolver is available
         *   If operation is a mutation, we can resolve offline because a corresponding
         *     mutation resolver is available
         *   If operationType is anything other than QUERY, we can't resolve offline
         *   Else operationType is a QUERY
         */
        if (!isResolverAvailable(rootResolver))
            return false;
        if (rootResolver.operationType === OperationTypeNode.MUTATION)
            return true;
        if (rootResolver.operationType !== OperationTypeNode.QUERY)
            return false;
        if (isOnline() && isOnlinePreferredQueries(operation)) {
            return false;
        }
        const nodeInfo = extractNodeInfoFromQueryVariables(operation);
        if (!nodeInfo || !nodeInfo.nodeId) {
            // If we can't extract nodeId, fallback to online
            return !isOnline();
        }
        const hasSynced = await isSyncBoxSynced(nodeInfo.tableName, nodeInfo.nodeId);
        return hasSynced;
    }
    catch (error) {
        // If any error occurs during the syncBox check, fallback to online
        console.warn('Error checking syncBox status, falling back to online:', error);
        return false;
    }
}
;
